import { ref } from "vue";
import { adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdate } from "@/api/admin-payments-scheduled-payments/admin-payments-scheduled-payments";
import type { RescheduleScheduledPaymentResponse } from "@/api/model";
import { useCurrentOrganization } from "@/composables/useCurrentOrganization";

interface RescheduleOptions {
  scheduledPaymentId: string;
  newScheduledAt: string;
  applyToAllFuture: boolean;
}

export function useReschedulePayment() {
  const isLoading = ref(false);
  const error = ref<string | null>(null);
  const result = ref<RescheduleScheduledPaymentResponse | null>(null);

  const reschedulePayment = async (
    options: RescheduleOptions
  ): Promise<boolean> => {
    const { currentOrganizationId } = useCurrentOrganization();

    if (!currentOrganizationId.value) {
      error.value = "Organization not found";
      return false;
    }

    isLoading.value = true;
    error.value = null;

    try {
      const response =
        await adminV1OrganizationsPaymentsScheduledPaymentsReschedulePartialUpdate(
          currentOrganizationId.value,
          options.scheduledPaymentId,
          {
            new_scheduled_at: options.newScheduledAt,
            apply_to_all_future: options.applyToAllFuture,
          }
        );

      result.value = response.data;
      return true;
    } catch (err: unknown) {
      error.value = "Failed to reschedule payment";
      console.error("Reschedule error:", err);
      return false;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    result,
    reschedulePayment,
  };
}
